<template>
    <div class="field" style="padding-right: 15px;">
        <div class="control">
            <div class="select is-primary">
                <select v-model="currentBid.status" v-on:change="statusChange">
                    <option value="">Status</option>
                    <option :value="this.$bidStatusCancel">Canceled</option>
                    <option :value="this.$bidStatusActive">Active</option>
                    <option :value="this.$bidStatusWin">Win</option>
                    <option :value="this.$bidStatusLose">Lose</option>
                    <option :value="this.$bidStatusLoseToOtherUser">Lose to other</option>
                    <option :value="this.$bidStatusUnsold">Unsold</option>
                    <option :value="this.$bidStatusUnderNegotiations">Negotiations</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import apiBids from '../../../../api/apiBids'
    export default {
        props: ['bid'],
        data() {
            return {
                isLoading: false,
                currentBid: {
                    id: this.bid.id,
                    status: ''
                },
                userRole: ''
            }
        },
        methods: {
            statusChange() {
                this.isLoading = true
                apiBids
                    .updateBidRequest(this.currentBid)
                    .then((response) => {
                        this.isLoading = false
                        this.bid.status = this.currentBid.status
                    })
                    .catch((err) => {
                        console.log(err)
                        this.isLoading = false
                    })
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Card/Buttons/Bids/BidStatus.vue